import NextImage from 'next/image';
import LazyLoad from 'react-lazyload';
import { APP_IMG } from 'src/constants';
export const IMAGE_SIZE = {
  XS: 'xs',
  XS_WEBP: 'xs-webp',
  MD: 'md',
  MD_WEBP: 'md-webp',
  LG: 'lg',
  LG_WEBP: 'lg-webp',
  XL: 'xl',
  XL_WEBP: 'xl-webp',
  XXL: 'xxl',
  XXL_WEBP: 'xxl-webp'
};
const Image = ({ image = '', title, external = false, externalLink = '', className = '', alt = '', isSvg = false }) => {
  const imgUrl = external ? (externalLink ? `${externalLink}${image}` : `${image}`) : `${APP_IMG}${image}`;
  const source = `${imgUrl}`;
  const images = (
    <picture className='resolution'>
      <source srcSet={`${imgUrl}`} media={'(max-width: 690px)'} type='image/webp' />
      <source srcSet={source} media={'(min-width: 691px)'} type='image/webp' />
      <img className={className} src={source} alt={alt || ''} title={title || 'image'} width='100%' height='100%' loading='lazy' />
    </picture>
  );

  return <LazyLoad offset={300}>{isSvg ? <NextImage className={className} src={`${image}`} alt={alt || ''} title={title || 'image'} width={'100%'} height={'100%'} /> : images}</LazyLoad>;
};

export default Image;
